import { Amplify } from "aws-amplify";

Amplify.configure({
  Auth: {
    region: "eu-west-1",
    userPoolId: "eu-west-1_ngQddijhG",
    userPoolWebClientId: "3k4t8jcsl7051fr3d2u7rguo4q",
  },
});
